export default "__VITE_ASSET__D67HFpJu__"